module.exports = __webpack_public_path__ + "src/assets/models/tractor/oil_stick.fbx";